import React, {useState} from 'react'
import { useForm } from '../../hooks/ useForm'
import Loading from '../tools/Loading'
import { Link } from 'react-router-dom'
const CardAsignatura = ({data, funcionUpName, funcionUpImg, loading}) => {
    const {nameSubject, photoURL, id, themes, students, likes, comments} = data
    const [value, handleInputChange] = useForm({title: nameSubject, imagen: ''});
    const {title, imagen} = value
    
    const [editTitle, setEditTitle] = useState(false)
    const [editImagen, setEditImagen] = useState(false)
    return (
        <div className='card_asig'>
            <div className='card_title'>
                {
                    editTitle
                    ?   <>
                            <input 
                                type='text' 
                                name='title' className='input_edit_asg' 
                                placeholder='Nombre de la asignatura' 
                                value={title}
                                onChange={handleInputChange}
                            />
                            <div className='asig_grid_controls'>
                                {
                                    loading
                                    ? <Loading />
                                    :
                                        <>
                                            <i 
                                                className='fas fa-save'
                                                onClick={() => funcionUpName(title, id)}
                                            ></i>
                                            <i 
                                                className='fas fa-window-close'
                                                onClick={() => setEditTitle(!editTitle)}
                                            ></i>
                                        </>
                                }
                                
                            </div>
                        </>
                    :   <>
                            <h3 className='txt_title'>{nameSubject}</h3>
                            <div className='asig_grid_controls'>
                                <i 
                                    className='far fa-edit'
                                    onClick={() => setEditTitle(!editTitle)}
                                ></i>
                            </div>
                        </>
                }
            </div>
            <div className='card_img'>
                <img src={photoURL} alt='Imagen' />
                <div className='asig_grid_controls'>
                    {
                        editImagen
                        ?
                            loading
                            ? 
                                imagen !== null && <Loading />
                            :
                                <>
                                    <label htmlFor={nameSubject}>
                                        <i className="btn fas fa-upload" ></i>
                                    </label>
                                    <input type="file" id={nameSubject} name='imagen' style={{display:'none'}}
                                        onChange={handleInputChange}
                                    />
                                    <i className='fas fa-save' onClick={() => funcionUpImg(imagen, id, nameSubject)}></i>
                                    <i  className='fas fa-window-close' onClick={() => setEditImagen(!editImagen)}></i>
                                </>
                        :<i  className='far fa-edit' onClick={() => setEditImagen(!editImagen)} > </i>
                    }
                </div>
            </div>
            <div className='card_body'>
                <div className='card_body1'>
                    <b>{themes}</b>
                    <i>Temas</i>
                </div>
                <div className='card_body2'>
                    <b>{students}</b>
                    <i>Estudiantes</i>
                </div>
                <div className='card_body3'>
                    <b>{likes}</b>
                    <i>Likes</i>
                </div>
                <div className='card_body4'>
                    <b>{comments}</b>
                    <i>Comentarios</i>
                </div>
                <div className='card_body5'>
                    <Link to={`/asignatura/${id}`}><i className='far fa-eye'></i></Link>
                    <Link to='/' ><i className='fas fa-users'></i></Link>
                    
                </div>
            </div>
        </div>
    )
}

export default CardAsignatura
